export const fullname = (obj) =>
{
	let name = obj?.fname;

	name += obj?.lname ? ` ${obj?.lname}` : '';

	return name;
};